import React from 'react';
import styles from './popconfirm.module.scss';
import { getIn18Text } from 'api';
const Popconfirm = (props) => {
    const { setShowDeletePop, handleDelete } = props;
    return (React.createElement("div", { className: styles.mailTemplateDeleteConfirmBox },
        React.createElement("p", { className: styles.confirmTitle }, getIn18Text('QUEDINGYAOSHANCHU13')),
        React.createElement("p", { className: styles.confirmBtn },
            React.createElement("span", { onClick: () => {
                    setShowDeletePop(false);
                } }, getIn18Text('QUXIAO')),
            React.createElement("span", { onClick: handleDelete }, getIn18Text('SHANCHU')))));
};
export default Popconfirm;
